<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card class="elevation-13">
        <v-toolbar color="accent" flat>
          <v-toolbar-title class="black--text">Login</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form v-if="!loadingState">
              <v-text-field
                :label="message[locale].email"
                prepend-icon="mdi-account"
                type="email"
                :rules="rules.email[locale]"
                v-model="email"
                outlined
              ></v-text-field>

              <v-text-field
                :label="message[locale].password"
                prepend-icon="mdi-lock"
                type="password"
                :rules="rules.required[locale]"
                v-model="password"
                outlined
              ></v-text-field>
              <p v-if="fail" class="red--text">Fel inloggningsuppgifter</p>
            </v-form>
            <v-row v-else justify="center" align="center">
              <v-col cols="2">
                <v-progress-circular indeterminate color="primary">
                </v-progress-circular>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class=""
            color="primary"
            :disabled="loadingState"
            @click="login"
          >
            {{ message[locale].login }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { emailRules, requiredRule } from "@/common/formRules.js";

export default {
  name: "Login",
  data() {
    return {
      message: {
        sv: { email: "E-post", password: "Lösenord", login: "Logga in" },
        en: { email: "Email", password: "Password", login: "Login" },
        ar: { email: "بريد الالكتروني", password: "كلمه السر", login: "يسجل دخول" }
      },
      email: "",
      password: "",
      fail: false,
      rules: { email: emailRules, required: requiredRule }
    };
  },
  computed: {
    locale() {
      return this.$store.getters.GET_LOCALE.value;
    },
    loadingState() {
      return this.$store.getters["user/GET_LOGIN_LOADING_STATE"];
    },
    user() {
      return this.$store.getters["user/GET_USER"];
    }
  },
  methods: {
    login() {
      this.fail = false;
      this.$store
        .dispatch("user/LOGIN", {
          email: this.email,
          password: this.password
        })
        .then(res => {
          if (res) {
            this.$nextTick(() => {
              this.$router.push("/");
            });
          } else {
            this.fail = true;
          }
        });
    }
  },
  mounted() {
    if (this.user) {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped></style>
